var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGuestIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 26,
    viewBox: "0 0 22 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.33333 5V3.66667C8.33333 2.95942 8.61428 2.28115 9.11438 1.78105C9.61448 1.28095 10.2928 1 11 1C11.7072 1 12.3855 1.28095 12.8856 1.78105C13.3857 2.28115 13.6667 2.95942 13.6667 3.66667V5M7 25V19.6667C7 18.9594 7.28095 18.2811 7.78105 17.781C8.28114 17.281 8.95942 17 9.66666 17H12.3333C13.0406 17 13.7189 17.281 14.2189 17.781C14.719 18.2811 15 18.9594 15 19.6667V25M9.66666 10.3333H12.3333M1.66666 21V13C1.66666 10.8783 2.50952 8.84344 4.00981 7.34315C5.5101 5.84286 7.54493 5 9.66666 5H12.3333C14.4551 5 16.4899 5.84286 17.9902 7.34315C19.4905 8.84344 20.3333 10.8783 20.3333 13V21C20.3333 22.0609 19.9119 23.0783 19.1618 23.8284C18.4116 24.5786 17.3942 25 16.3333 25H5.66666C4.6058 25 3.58838 24.5786 2.83824 23.8284C2.08809 23.0783 1.66666 22.0609 1.66666 21Z",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuestIcon);
export default __webpack_public_path__ + "static/media/guest-icon.2043b3d5042e5cae333d144d0fda2ee4.svg";
export { ForwardRef as ReactComponent };